import { get_base_url } from '@/shared/http/client';
import { DEFAULT_CLIENT_ID } from '@/config/client';
import { getTrainingTaskDisplayName } from '@/features/trainings/components/trainingsUtils';
import { decidedBaseModelName } from '@/features/trainings/api/baseModelsApi';

/**
 * Fetch all trainings and enrich each row with its usecase's display /
 * deployment fields — the minimal shape the Configure Deployment modal's
 * Add-Task picker and version selects need. Mirrors the enrichment the
 * Models page does in `Trainings.jsx`; used by surfaces (e.g. the task
 * page's Model Details drawer) that have no trainings list of their own.
 */
export async function fetchTrainingsForConfigureModal({
  allUsecases = [],
  clientId = DEFAULT_CLIENT_ID,
} = {}) {
  const url = `${get_base_url(window.location.origin)}/trainings`;
  const response = await fetch(url, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ value: clientId }),
  });
  if (!response.ok) {
    throw new Error(
      `Failed to load trainings: ${response.status} ${response.statusText}`
    );
  }

  const responseJson = await response.json();
  const rows = Array.isArray(responseJson?.trainings)
    ? responseJson.trainings
    : [];
  const usecaseById = new Map((allUsecases || []).map((u) => [u._id, u]));

  return rows.map((row) => {
    const usecase = usecaseById.get(row.llm_usecase_id) || null;
    return {
      ...row,
      group_name: usecase?.group_name || 'Unnamed Project',
      usecase_name: getTrainingTaskDisplayName(usecase),
      objective_name: usecase?.usecase_name || '',
      base_model_name: decidedBaseModelName(row.base_model_name) || usecase?.base_distilled_model || '',
      task_type: usecase?.task_type ?? row.task_type ?? null,
      version: row.version || 1,
      status: row.status || 'unknown',
      deployed_version: usecase?.deployed_version ?? null,
      is_deployed: Boolean(usecase?.is_deployed),
      usecase_status: usecase?.status ?? null,
      client_id: usecase?.client_id || null,
    };
  });
}
